(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGrid(root) {
    root.querySelectorAll('.pc-card').forEach(initCard);
  }

  function initCard(card) {
    var variantId = card.dataset.variantId;
    var addBtn = card.querySelector('[data-role="add"]');
    var stepper = card.querySelector('[data-role="stepper"]');
    if (!addBtn || !stepper) return; // sold out cards have no controls

    var qtyEl = stepper.querySelector('[data-role="qty"]');
    var lineItemKey = null;
    var qty = 0;

    function setQty(newQty) {
      qty = newQty;
      qtyEl.textContent = qty;
      if (qty <= 0) {
        stepper.hidden = true;
        addBtn.hidden = false;
        lineItemKey = null;
      } else {
        stepper.hidden = false;
        addBtn.hidden = true;
      }
    }

    function postJSON(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) throw new Error('Cart request failed');
        return res.json();
      });
    }

    addBtn.addEventListener('click', function () {
      addBtn.classList.add('is-loading');
      postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
        .then(function (data) {
          var item = data.items ? data.items[0] : data;
          lineItemKey = item.key;
          setQty(item.quantity || 1);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function (err) {
          console.error(err);
          alert('Could not add item to cart. Please try again.');
        })
        .finally(function () {
          addBtn.classList.remove('is-loading');
        });
    });

    stepper.addEventListener('click', function (e) {
      var action = e.target.dataset.action;
      if (!action || !lineItemKey) return;

      var newQty = action === 'increase' ? qty + 1 : qty - 1;
      stepper.classList.add('is-loading');

      postJSON('/cart/change.js', { id: lineItemKey, quantity: newQty })
        .then(function () {
          setQty(newQty);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function (err) {
          console.error(err);
          alert('Could not update cart. Please try again.');
        })
        .finally(function () {
          stepper.classList.remove('is-loading');
        });
    });
  }

  document.querySelectorAll('.pc-grid-section').forEach(initGrid);
})();

  } catch(e) { console.error(e); }
})();
})();
